import React from "react";

const InvoiceHeader = ({ header }) => {
  // Logika mendeteksi apakah ini Halaman 1 atau bukan
  // header.page_info biasanya berisi format "PAGE 1 OF 3"
  const isFirstPage = !header.page_info || header.page_info.includes("PAGE 1");

  return (
    <div className="mb-6 font-sans">
      
      {/* 1. BAGIAN ATAS: KOP SURAT (HANYA MUNCUL DI HALAMAN 1) */}
      {isFirstPage && (
        <div className="mb-8">
          <div className="flex flex-col items-start gap-1 mb-1">
               <img src="/logo.png" alt="Logo" className="h-14 w-auto object-contain block mb-2" />
               <div>
                  <h1 className="text-lg font-bold tracking-wide uppercase text-black-900 leading-none mb-1">
                      PT. SAYAP BIRU EKSPRES
                  </h1>
                  <div className="text-xs leading-relaxed text-black-900">
                      <p>Cahaya Palmerah Building Lt. 1 Ruang 105</p>
                      <p>Jl. Palmerah Utara III No. 09, Palmerah, Jakarta Barat 11480</p>
                      <p>Tlp.: (021) 530 8973, 530 8974</p>
                      <p>NPWP: 00.334.663.0-107.7000</p>
                  </div>
               </div>
          </div>
        </div>
      )}

      {/* 2. BAGIAN TENGAH: INFO CUSTOMER & INFO INVOICE */}
      <div className="flex justify-between items-end">
        
        {/* KIRI: INFO CUSTOMER (TO) */}
        <div className="w-[55%] text-xs">
            <div className="font-bold mb-1 text-sm">To:</div>
            
            {/* REVISI: Nama PT digabung dengan Customer ID */}
            <p className="text-sm font-bold uppercase mb-1">
                {header.customer_name} ( {header.customer_id} )
            </p> 
            
            <div className="uppercase text-black-900 leading-snug w-[90%]">
                {header.customer_building && <p>{header.customer_building}</p>}
                <p>{header.customer_address1}</p>
                <p>{header.customer_address2}</p>
                <p>{header.customer_city} {header.customer_post_code}</p>
            </div>

            <div className="mt-2">
                {/* REVISI: NPWP diletakkan tepat sebelum Attn */}
                {header.customer_npwp && (
                    <div className="mb-0.5">
                        <span className="font-bold mr-1">NPWP:</span>
                        <span>{header.customer_npwp}</span>
                    </div>
                )}
                <div>
                    <span className="font-bold mr-1">Attn:</span>
                    <span>{header.department || "-"}</span>
                </div>
            </div>
        </div>

        {/* KANAN: INFO INVOICE */}
        <div className="w-[40%] text-xs mb-1 text-right"> 
             
             {/* Judul INVOICE hanya muncul di halaman 1, karena di halaman 2+ judulnya sudah ada tulisan INVOICE CONTINUATION */}
             {isFirstPage && (
                 <h2 className="text-xl font-bold mb-2 tracking-widest mr-16">INVOICE</h2>
             )}

             <div className="grid grid-cols-[80px_10px_1fr] gap-y-1 text-left ml-auto w-fit mt-2">
                <div className="font-bold">INVOICE NO</div>
                <div className="text-center">:</div>
                <div className="font-bold">{header.invoice_number}</div>

                {header.revision > 0 && <>
                <div className="font-bold">REVISION</div>
                <div className="text-center">:</div>
                <div className="font-bold">{header.revision}</div>
                </>}

                <div className="font-bold">DATE</div>
                <div className="text-center">:</div>
                <div>
                    {header.invoice_date 
                        ? new Date(header.invoice_date).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) 
                        : (header.date ? new Date(header.date).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : "-")
                    }
                </div>

                <div className="font-bold">DUE DATE</div>
                <div className="text-center">:</div>
                <div>{header.due_date ? new Date(header.due_date).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' }) : "-"}</div>

                <div className="font-bold">PAGE</div>
                <div className="text-center">:</div>
                <div>{header.page_info || 1}</div>
             </div>
        </div>

      </div>
    </div>
  );
};

export default InvoiceHeader;